import {
  CheckCircleIconCustomSize,
  Drawer,
  SignatureIcon,
  Tooltip,
} from "components";
import { BillingEmailFields } from "./BillingEmailFields";
import { useState, useRef, useMemo } from "react";
import { BillingExpenseFields } from "./BillingExpenseFields";
import { BillingProductFields } from "./BillingProductFields";
import { BillingTaxFields } from "./BillingTaxFields";
import { AddTaxContent } from "shared/features/billing/AddTaxContent";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { AddNewDiscountContent } from "shared";
export const DrawerComponent = (data: any) => {
  const theme = useTheme();
  const { isDrawerOpen, closeDrawer, componentName, mode } = data;
  const buttonRef = useRef<any>(null);

  let DrawerContent;
  switch (componentName) {
    case "Billing Templates":
      DrawerContent = BillingEmailFields;
      break;
    case "Add Expense":
      DrawerContent = BillingExpenseFields;
      break;
    case "Add Product":
      DrawerContent = BillingProductFields;
      break;
    case "Add Tax":
      DrawerContent = BillingTaxFields;
      break;
    default:
      DrawerContent = null;
  }

  const onSubmitCall = () => [
    "Add Discount",
    "Edit Discount",
    "Add Tax",
    "Edit Tax",
  ];

  const [signatureOptionsAnchorEl, setSignatureOptionsAnchorEl] =
    useState<any>(null);
  const [isAddSignature, setIsAddSignature] = useState(false);
  const signatureOptionsData = useMemo(
    () => [
      {
        label: "Company Signature",
        value: "company",
        icon: <SignatureIcon />,
        isSignature: true,
        isDisabled: false,
        isHidden: false,
      },
    ],
    [],
  );

  return (
    <>
      <Drawer
        onOpen={() => {}}
        isPrimaryButtonDisabled={mode?.primaryButtonDisable ? true : false}
        open={isDrawerOpen}
        onClose={() => {
          buttonRef.current.cancelButtonClick();
        }}
        title={componentName}
        headerTitleStyleSx={{ marginLeft: "8px" }}
        primaryButtonText={
          (mode?.method || mode) === "create" ? "Save" : "Update"
        }
        secondaryButtonText="Cancel"
        footerStyles={{
          display: "flex",
          justifyContent:
            componentName === "Billing Templates"
              ? "space-between"
              : "flex-end",
        }}
        footerLeftActionComponent={
          componentName === "Billing Templates" ? (
            <>
              <Tooltip title="Add signature">
                <IconButton
                  onClick={(e) => setSignatureOptionsAnchorEl(e.currentTarget)}
                  sx={{
                    width: "20px",
                    height: "20px",
                    color: "lightBg.main",
                    ":hover": { bgcolor: "transparent" },
                  }}
                >
                  <SignatureIcon color="inherit" />
                </IconButton>
              </Tooltip>
              <Menu
                open={Boolean(signatureOptionsAnchorEl)}
                anchorEl={signatureOptionsAnchorEl}
                onClose={() => setSignatureOptionsAnchorEl(null)}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiList-root": { p: "0px", pt: "8px", pb: "8px" },
                }}
                PaperProps={{
                  sx: {
                    margin: "16px 0px",
                    padding: "0px",
                    overflow: "scroll",
                    maxHeight: "200px",
                    width: "210px",
                    maxWidth: "230px",
                    backgroundColor: "#FFFFFF",
                    overflowX: "clip",
                    minWidth: "175px",
                    borderRadius: "8px",
                    boxShadow:
                      "0px 0px 4px 0px rgba(0, 0, 0, 0.06), 0px 0px 2px 0px rgba(0, 0, 0, 0.04)",
                    border: `1px solid ${theme.palette.neutral["015"]}`,
                  },
                }}
              >
                {signatureOptionsData
                  .filter((opt: any) => !opt.isHidden)
                  .map((option: any) => {
                    return (
                      <MenuItem
                        key={option.value}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsAddSignature((prev) => !prev);
                          setSignatureOptionsAnchorEl(null);
                        }}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          textTransform: "capitalize",
                          gap: "8px",
                          backgroundColor: isAddSignature
                            ? theme.palette.neutral["B-005"]
                            : "transparent",
                          ":hover": {
                            bgcolor: isAddSignature
                              ? theme.palette.neutral["B-005"]
                              : "",
                          },
                        }}
                        disabled={option.isDisabled}
                      >
                        <Stack direction="row" alignItems="center" gap={1}>
                          {option.icon}
                          <Typography
                            variant="body-small"
                            sx={{
                              fontWeight: isAddSignature ? "bold" : "normal",
                            }}
                          >
                            {option.label}
                          </Typography>
                        </Stack>
                        {option.isSignature &&
                          isAddSignature &&
                          !option?.isDisabled && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CheckCircleIconCustomSize
                                height="20px"
                                color="success"
                              />
                            </Box>
                          )}
                      </MenuItem>
                    );
                  })}
              </Menu>
            </>
          ) : (
            <></>
          )
        }
        onPrimaryButtonClick={() => {
          if (onSubmitCall().includes(componentName)) {
            // taxRef.current?.onSubmit?.();
            buttonRef.current.onSubmit?.();
          } else {
            buttonRef.current.saveButtonClick();
          }
        }}
        onSecondaryButtonClick={() => {
          if (onSubmitCall().includes(componentName)) {
            closeDrawer();
            return;
          }
          buttonRef.current.cancelButtonClick();
        }}
      >
        {componentName === "Billing Templates" && (
          <BillingEmailFields
            ref={buttonRef}
            closeDrawer={() => {
              closeDrawer();
              setIsAddSignature(false);
            }}
            mode={mode}
            isDrawerOpen={isDrawerOpen}
            isAddSignature={isAddSignature}
          />
        )}
        {(componentName === "Add Expense" ||
          componentName === "Edit Expense") && (
          <BillingExpenseFields
            ref={buttonRef}
            closeDrawer={closeDrawer}
            mode={mode}
          />
        )}
        {(componentName === "Add Product" ||
          componentName === "Edit Product") && (
          <BillingProductFields
            ref={buttonRef}
            closeDrawer={closeDrawer}
            mode={mode}
          />
        )}

        {(componentName === "Add Tax" || componentName === "Edit Tax") && (
          // <BillingTaxFields
          //   ref={buttonRef}
          //   closeDrawer={closeDrawer}
          //   mode={mode}
          // />
          <Box sx={{ width: "400px", height: "100%" }}>
            <AddTaxContent
              // ref={taxRef}
              ref={buttonRef}
              closeDrawer={closeDrawer}
              onSubmit={(data) => {
                closeDrawer();
              }}
              mode={mode}
            />
          </Box>
        )}
        {(componentName === "Add Discount" ||
          componentName === "Edit Discount") && (
          <Box sx={{ width: "400px", height: "100%" }}>
            <AddNewDiscountContent
              ref={buttonRef}
              // closeDrawer={closeDrawer}
              onSubmit={(data) => {
                closeDrawer();
              }}
              // mode={mode}
              selectedDiscount={mode?.data}
              closeDrawer={closeDrawer}
            />
          </Box>
        )}
        {/* {DrawerContent && (
          <DrawerContent ref={buttonRef} closeDrawer={closeDrawer} />
        )} */}
      </Drawer>
    </>
  );
};
